import React, { useMemo, useState } from "react";
import {
  FaChevronDown,
  FaChevronUp,
  FaQuestionCircle,
  FaSearch,
} from "react-icons/fa";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    if (!query.trim()) return faqList;
    const q = query.toLowerCase();
    return faqList.filter(
      (f) =>
        f.question.toLowerCase().includes(q) || f.answer.toLowerCase().includes(q)
    );
  }, [query]);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="bg-neutral-100/60 py-10 sm:py-14">
      <div className="max-w-5xl mx-auto px-4">
        <div className="relative rounded-2xl bg-white ring-1 ring-black/10 shadow-[0_24px_80px_rgba(0,0,0,0.25)]">
          {/* Header */}
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between p-6 sm:p-8">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">
              FAQ
            </h1>

            <div className="w-full sm:w-80">
              <label className="relative block">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                  <FaSearch />
                </span>
                <input
                  type="text"
                  placeholder="Search..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  className="w-full rounded-full border border-gray-200 bg-gray-50/80 pl-10 pr-4 py-2.5 text-sm text-gray-700 placeholder:text-gray-400 outline-none focus:border-gray-300 focus:bg-white focus:ring-2 focus:ring-gray-200 transition"
                />
              </label>
            </div>
          </div>

          {/* List */}
          <div className="px-4 sm:px-6 pb-6 sm:pb-8">
            <div className="space-y-4">
              {filtered.map((faq, idx) => {
                const isOpen = openIndex === idx;
                return (
                  <div
                    key={idx}
                    className="rounded-xl bg-white ring-1 ring-black/5 shadow-sm hover:shadow-md transition"
                  >
                    <button
                      onClick={() => toggle(idx)}
                      className="w-full flex items-center justify-between text-left p-4 sm:p-5"
                    >
                      <div className="flex items-center gap-3 text-base sm:text-lg font-semibold text-gray-800">
                        <FaQuestionCircle className="text-gray-500" />
                        <span className="truncate">{faq.question}</span>
                      </div>

                      <span className="ml-4 text-rose-400 text-lg sm:text-xl">
                        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                      </span>
                    </button>

                    {isOpen && (
                      <div className="px-5 pb-5 -mt-2 text-sm sm:text-base text-gray-600 leading-relaxed">
                        {faq.answer}
                      </div>
                    )}
                  </div>
                );
              })}

              {filtered.length === 0 && (
                <div className="rounded-xl bg-white ring-1 ring-black/5 p-6 text-center text-gray-500">
                  No results for “{query}”.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const faqList = [
  {
    question: "What is this platform about?",
    answer:
      "We offer a powerful platform that connects industry-leading manufacturers and innovative sellers with thousands of construction companies, contractors, and engineers across India. Our goal is to help businesses grow through greater visibility and direct access to the construction industry.",
  },
  {
    question: "Who can join the platform?",
    answer:
      "Manufacturers, sellers, distributors, and suppliers of construction-related products and materials are welcome to join. We support a wide range of product categories, from hand tools to heavy machinery.",
  },
  {
    question: "How will this platform help my business grow?",
    answer:
      "By listing your products here, you gain exposure to a large and relevant audience. Our platform helps you reach verified buyers from the construction sector, leading to more inquiries and sales.",
  },
  {
    question: "Is there a fee to register as a seller or manufacturer?",
    answer:
      "We offer different plans based on your business size and needs. Contact our team for detailed pricing and promotional offers.",
  },
  {
    question: "What type of construction businesses use this platform?",
    answer:
      "Our users include small to large-scale construction companies, civil engineers, site contractors, interior designers, builders, and project managers from across India.",
  },
  {
    question: "How do I list my products?",
    answer:
      "Once registered, you can easily add your product details, images, specifications, and pricing through your seller dashboard. Our support team is always available to guide you through the process.",
  },
  {
    question: "Can I track orders and customer interactions?",
    answer:
      "Yes. Our platform provides a comprehensive dashboard where you can manage inventory, track orders, respond to customer queries, and analyze performance.",
  },
  {
    question: "Do you offer marketing support?",
    answer:
      "Absolutely! We help promote your brand and products through targeted campaigns, SEO optimization, and social media outreach.",
  },
  {
    question: "Is my data secure on this platform?",
    answer:
      "Yes. We use industry-standard security measures to ensure that your business data and customer information remain safe.",
  },
  {
    question: "How can I get started?",
    answer:
      "Simply sign up on our platform, complete your business profile, and start uploading your products. For assistance, you can reach out to our onboarding support team.",
  },
];

export default FAQ;
